import React, { FC, HtmlHTMLAttributes, useEffect, useState, MouseEvent } from "react";
import PhoneNumberStyled from "./PhoneNumberStyled";
import Phone from "../Icons/fill/Phone";
import { Phone as PhoneOutline } from "../Icons/outline";
import { useSelector } from "react-redux";
import { ReduxState } from "~/types/redux";
import { stringify } from "~/helpers/filters";
import { trackEvent } from "~/helpers/tracking";

interface Props extends HtmlHTMLAttributes<HTMLDivElement> {
  number?: string;
  showIcon?: boolean;
}

const PhoneNumber: FC<Props> = ({ number = "", showIcon = true, ...props }) => {
  const { singleForm } = useSelector((store: ReduxState) => store);
  const Icon = singleForm?.enabled ? <PhoneOutline /> : <Phone />;

  const [phoneNumber, setPhoneNumber] = useState(number);
  useEffect(() => setPhoneNumber(phoneNumber), [phoneNumber]);

  const handlePhoneClick = (event: MouseEvent<HTMLAnchorElement>): void => {
    const { target } = event;
    const { text, actionOutcome } = JSON.parse((target as HTMLElement).getAttribute("data-payload"));
    trackEvent({
      action: "elementClicked",
      data: {
        text,
        actionOutcome,
      },
    });
  };
  return (
    <PhoneNumberStyled
      singleForm={singleForm?.enabled}
      href={`tel:${number}`}
      tabIndex={-1}
      data-payload={stringify({
        text: `Phone Number ${number}`,
        actionOutcome: "CLICKTOCALL",
      })}
      onClick={handlePhoneClick}
      data-testid="footer-phone-number"
      {...props}
    >
      {showIcon && Icon}
      {number}
    </PhoneNumberStyled>
  );
};

PhoneNumber.displayName = "PhoneNumber";

export default PhoneNumber;
